import {style} from '@vanilla-extract/css'

export const dialogInnerContainer = style({
  height: '40rem',
})
